// extracted by mini-css-extract-plugin
export default {"slideContainer":"_010f4edab8 e335a0808d _20b9a76cf1","slideImage":"fdca3bcc0e"};